<template>
<md-layout md-gutter class="register-doctor" style="    padding: 3em 2.5em;">
    <div class="col-sm-12">
        <h1 class="text-center">{{translate.pages.plans.know_ours_plans}}</h1>
        <!-- TODO: Update settings admin -->
        <!-- <p class="text-center">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Placeat, fuga tenetur nulla quo adipisci harum, corrupti quidem, excepturi impedit provident voluptatibus ipsam fugiat commodi odit est eum magni velit totam.</p> -->
    </div>
    <div class="clearfix"></div>
    <div class="col-sm-12">
        <div class="col-sm-4 " v-for="(plan,index) in data.plans">
            <md-card style="padding-top: 3em; padding-bottom: 3em;">
                <md-card-header class="text-center">
                    <span style="color: #b0b5bf; font-size: 18pt; text-transform: uppercase;" v-html="plan.name">
                    </span>
                    <br/>
                    <br/>
                    <br/>
                    <span style="color:#cbd0d6;">
                        <strong style="color:#2c4760; font-size:2.5em">{{plan.price}}</strong> <span style="font-size: 1.5em;"><sup>CLP</sup>/<sub>mes</sub></span>
                    </span>
                    <br>
                    <br>
                    <hr style="border: 1px solid #959ea6; opacity: 0.1">
                </md-card-header>
                <md-card-content>
                    <br/>
                    <div class="text-center mt-plan-description" v-html="plan.description"></div>
                    <div class="text-center">
                        <br/>
                        <md-button class="md-raised md-primary" v-if="data.activePlan !== plan.id" @click.native="changePlan(plan.id)">{{translate.pages.plans.know_more}}</md-button>
                        <div v-else style="height: 49px;">
                            <br/>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>
    </div>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="dialog1">
        <md-dialog-content>{{ alert.msg }}</md-dialog-content>
        <md-dialog-actions>
            <md-button class="md-primary" @click.native="closeDialog('dialog1')">Ok</md-button>
        </md-dialog-actions>
    </md-dialog>
</md-layout>
</template>
<script>
    var language = window.navigator.userLanguage || window.navigator.language;
    import { login } from '../../config/api.js';
    //console.log(language);
    export default {
        data() {
            return {
                language: 'es',
                alert: {
                    msg : '',
                },
                alert: {
                    ok : 'OK',
                    msg : '',
                },
                doctor : {
                    notification_appointment : false,
                    notification_mail : false,
                    notification_sms : false,
                    type: 'doctor',
                },
                data: {
                    plans: [],
                    activePlan: '',
                }
            }
        },
        mounted(){
            self = this;
            // Get Plan
            this.$http.get('/admin/plan', {
                    headers: {
                        Authorization : 'Bearer '+ this.$auth.getToken(),
                    }
                }).then(response => {
                    if(response.data.status == "OK"){
                        self.data.plans = response.data.data;
                    }
                });
            // Get profile doctor
            this.$http.get('/doctor/me', {
                    headers: {
                        Authorization : 'Bearer '+ this.$auth.getToken(),
                    }
                }).then(response => {
                    if(response.data.status == "OK"){
                        self.doctor = response.data.data;
                        self.data.activePlan = response.data.data.plan_id;
                    }
                });
        },
        methods: {
            // Open Modal
            openDialog(ref) {
                this.$refs[ref].open();
            },
            // Close modal
            closeDialog(ref) {
                this.$refs[ref].close();
                self.alert.msg = '';
            },
            onOpen() {
                console.log('Opened');
            },
            onClose(type) {
                console.log('Closed', type);
            },
            // Change plan
            changePlan(plan_id){
              this.$http.post('/admin/plan/change', { plan_id : plan_id }, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                    .then(response => {
                        if(response.data.status == "OK"){
                            self.alert.msg = response.data.msg;
                            self.data.activePlan = plan_id;
                        }else{
                            self.alert.msg = response.data.msg;
                        }
                        this.openDialog('dialog1');
                    }).catch(error => {
                        console.log(error);
                    });
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../assets/styles/variables/color.styl'
    @import '../../assets/styles/boots.styl'
    .mt-plan-description
        color #959ea6
        font-size 12pt
    .mt-plan-description strong
        color #000000!important
</style>


// WEBPACK FOOTER //
// Plans.vue?add2e906